<template>
  <div class="max-w-4xl mx-auto space-y-6">
    <!-- Page header -->
    <div class="flex items-center gap-3">
      <span class="flex items-center justify-center w-10 h-10 rounded-xl bg-taxiye-100 text-taxiye-500">
        <span class="material-icons-round">manage_accounts</span>
      </span>
      <div>
        <h2 class="text-lg font-semibold text-gray-800">Edit Passenger</h2>
        <p class="text-sm text-gray-500">Update this passenger's profile.</p>
      </div>
    </div>

    <form @submit.prevent="update" class="space-y-6">
      <!-- Basic information -->
      <div class="p-6 bg-white border border-gray-200 shadow-sm rounded-2xl">
        <div class="flex items-center mb-5 space-x-1 text-gray-500">
          <span class="text-base material-icons-round">badge</span>
          <span class="text-xs font-semibold tracking-widest uppercase">Basic Information</span>
        </div>

        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <label class="block">
            <span class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">First Name</span>
            <input
              v-model="passenger.firstName"
              class="w-full h-10 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              placeholder="Jane"
            />
          </label>
          <label class="block">
            <span class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Last Name</span>
            <input
              v-model="passenger.lastName"
              class="w-full h-10 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              placeholder="Doe"
            />
          </label>
          <label class="block">
            <span class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Email</span>
            <input
              v-model="passenger.email"
              type="email"
              class="w-full h-10 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              placeholder="johndoe@gmail.com"
            />
          </label>
          <label class="block">
            <span class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Contact Number</span>
            <input
              v-model="passenger.phoneNumber"
              type="tel"
              class="w-full h-10 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              placeholder="+251 912345678"
            />
          </label>
        </div>

        <div class="mt-5">
          <span class="block mb-2 text-xs font-semibold tracking-wider text-gray-600 uppercase">Profile Picture</span>
          <input
            type="file"
            class="w-full text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
          />
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-end gap-3">
        <back-button></back-button>
        <button
          type="submit"
          class="inline-flex items-center h-10 px-5 text-sm font-semibold text-white shadow-sm rounded-xl bg-taxiye-500 transition-colors duration-150 hover:bg-taxiye-600"
        >
          <span class="mr-1 text-base material-icons-round">check</span>
          Update Passenger
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import BackButton from "@/components/BackButton.vue";

export default {
  components: {
    BackButton,
  },
  data() {
    return {
      passenger: {},
    };
  },
  created() {
    this.getRider();
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    getRider() {
      this.$misc
        .get(`users/${this.id}`)
        .then(response => (this.passenger = response.data))
        .catch(err => console.log(err));
    },
    update() {
      this.$misc
        .patch(`users/${this.id}`, { ...this.passenger })
        .then(() => {
          window.flash({
            type: "success",
            body: "Passenger information was updated successfully!",
          });
          this.$router.push("/passengers");
        })
        .catch(err => console.log(err));
    },
  },
};
</script>
